import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import user from './user'
import tab from '@/components/Tab/store'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    app,
    user,
    tab
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js